var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{attrs:{"flat":"","small":"","color":_vm.chip_options.bg,"dark":_vm.chip_options.dark},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v(" "+_vm._s(_vm.chip_options.text)+" "),(_vm.situacao == -2)?_c('v-icon',{staticClass:"pointer",attrs:{"right":""}},[_vm._v("mdi-information-outline")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }